<template>
    <div class="wrap-content">
        <div class="data-import small-card">
            <div class="row">
                <div
                    v-for="(data, index) in allowedDataHeader"
                    :key="index"
                    class="col-md-3"
                    :class="data.link == tabActive ? 'active' : ''"
                    @click="tabFilter(data.link)"
                >
                    <card-data
                        :logo="data.logo"
                        :name="data.name"
                        :description="data.description"
                    ></card-data>
                </div>
            </div>
            <router-view></router-view>
        </div>

        <!-- Delta list -->
        <div v-if="tabData == 3">
            <router-view />
        </div>
    </div>
</template>

<script>
import cardData from '@/components/CardData.vue'
// import uploadFile from '@/components/UploadFile.vue'
import { directive as onClickOutside } from 'vue-on-click-outside'
import { mapGetters } from 'vuex'

export default {
    components: {
        cardData,
    },

    directives: {
        onClickOutside: onClickOutside,
    },

    data() {
        return {
            tabActive: 'client-black-list',
            importDataHeader: [
                {
                    logo: 'logo3.png',
                    name: 'CLIENT LIST',
                    description: "Manage Client's Blacklist Data",
                    active: false,
                    link: 'client-black-list',
                    permission: ['client-black-list'],
                },
                {
                    logo: 'logo3.png',
                    name: 'DATA ENTRY',
                    description: 'Manage Data Entry',
                    active: false,
                    link: 'data-entry-list',
                    permission: ['data-entry-list'],
                },
                {
                    logo: 'logo5.png',
                    name: 'IDENFO LIST',
                    description: "Manage Idenfo's Blacklist Data",
                    active: false,
                    link: 'idenfo-black-list',
                    permission: ['idenfo-black-list'],
                },
                // {
                //     logo: 'logo2.png',
                //     name: 'WORLD-CHECK',
                //     description: 'Manage World Check Data',
                //     active: false,
                //     link: 'world-check',
                //     permission: ['world-check-list'],
                // },
                // {
                //     logo: 'logo1.png',
                //     name: 'DOW JONES',
                //     description: 'Manage Dow Jones Data',
                //     active: false,
                //     link: 'dow-jones',
                //     permission: ['dow-jones-list'],
                // },
                {
                    logo: 'logo3.png',
                    name: 'Configuration | Delta List',
                    description: 'Manage Delta List Data',
                    active: false,
                    link: 'delta-list',
                    permission: ['view-screening-data'],
                },
                // =======
                //                     logo: 'logo3.png',
                //                     name: 'IDENFO LIST',
                //                     description: "Manage Idenfo's Blacklist Data",
                //                 },
                //                 // {
                //                 //     logo: 'logo3.png',
                //                 //     name: 'CLIENT LIST',
                //                 //     description: "Manage Client's Blacklist Data",
                //                 // },
                // >>>>>>> 60316e146601dc6fe208b1cb2ab64c446721ba0a
            ],
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['scopes', 'showPageLoader']),

        allowedDataHeader() {
            return this.importDataHeader.filter((item) => {
                return this.checkPermission(item.permission)
            })
        },
    }, // End of Component > computed

    mounted() {
        // tab on refresh
        var path = this.$route.path.split('/')
        this.tabActive = path.find((element) => {
            return (
                element == 'client-black-list' ||
                element == 'idenfo-black-list' ||
                element == 'dow-jones' ||
                element == 'world-check' ||
                element == 'data-entry-list' ||
                element == 'delta-list'
            )
        })
    },

    methods: {
        tabFilter(link) {
            this.tabActive = link
            if (link == 'dow-jones') {
                this.$router.push('/configuration/screening-data/dow-jones')
            } else if (link == 'world-check') {
                this.$router.push('/configuration/screening-data/world-check')
            } else if (link == 'idenfo-black-list') {
                this.$router.push(
                    '/configuration/screening-data/idenfo-black-list'
                )
            } else if (link == 'client-black-list') {
                this.$router.push(
                    '/configuration/screening-data/client-black-list'
                )
            } else if (link == 'data-entry-list') {
                this.$router.push(
                    '/configuration/screening-data/data-entry-list'
                )
            } else if (link == 'delta-list') {
                this.$router.push('/configuration/screening-data/delta-list')
            }
        },

        checkPermission(scopes) {
            return !!_.intersection(scopes, this.scopes).length
        },
    },
}
</script>
